module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-flex uk-flex-middle",
    attrs: {
      "id": "login-page-container"
    }
  }, [_c('div', {
    staticClass: "uk-width uk-flex uk-flex-wrap uk-flex-center"
  }, [_c('header', {
    staticClass: "uk-width uk-text-center uk-text-middle"
  }, [_c('img', {
    attrs: {
      "src": _vm.config.logo_url,
      "alt": "Logo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-section uk-section-primary uk-light uk-width-1-2@m",
    attrs: {
      "id": "login"
    }
  }, [_c('div', {
    staticClass: "uk-container"
  }, [_c('h3', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n          Resetowanie hasła\n        ")]), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset"
  }, [_vm._v("\n            " + _vm._s(_vm.info) + "\n          ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb1ecc24"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Resetpass.vue
// module id = 276
// module chunks = 1